import React from "react";
import { Route } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import { useAppConfig } from "@fdoh/health-ui-react";
import { DBProtectedRouteProps } from "./DBProtectedRoute.types";
import { UnAuthorized } from "./UnAuthorized";
import useDBAuthService from "../hooks/useDBAuthService";

export const DBProtectedRoute = ({ children, ...rest }: DBProtectedRouteProps) => {
    const config = useAppConfig();
    const application = config.applications.filter(x => x.name === "privateProviderInspectionApi")[0];
    const userStatus = useDBAuthService(application);

    return (
        <Route
            {...rest}
            render={() => {                
                switch (userStatus) {
                    case 'UserAuthenticated': {
                        return children;
                    }
                    case 'ClaimsObjectIDFailed': {
                        return <UnAuthorized title="Authentication failed!" errorMessage="User is active, but the authentication failed on Claims Object Id." />;
                    }
                    case 'UserDisabled': {
                        return <UnAuthorized title="User Inactive!" errorMessage="User is not active in the system." />;
                    }
                    case 'UserNotFound': {
                        return <UnAuthorized title="User not found!" errorMessage="No account found for the user." />;
                    }
                    case 'Error': {
                        return <UnAuthorized title="Error!" errorMessage="Error authenticating the user." />;
                    }
                };
            }}
        />
    );
};

export default DBProtectedRoute;
